import { makeStyles, Theme } from '@material-ui/core/styles';

export const useComposerStyles = makeStyles((theme: Theme) => ({
    '@keyframes statusPulse': {
        '0%, 100%': { transform: 'scale(1)', opacity: 0.8 },
        '50%': { transform: 'scale(1.12)', opacity: 1 },
    },
    composer: {
        borderTop: `1px solid ${theme.palette.divider}`,
        flexShrink: 0,
        padding: theme.spacing(1.5, 2),
    },
    listening: {
        animation: '$statusPulse 1.2s ease-in-out infinite',
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
    },
}));
